import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PumpCard from './PumpCard';
import './Dashboard.scss';

export default function PumpList({
  pumps,
  selectedPumpId,
  onPumpClick,
  selectModeEnabled,
  selectedPumpIds = [],
  onSelectionChange,
  onSelectAll,
  onOpenBulkUpdate,
}) {
  const { t } = useTranslation();
  const handleRowClick = (pump, e) => {
    if (selectModeEnabled && e.target.closest('.pump-list-checkbox')) return;
    if (onPumpClick) onPumpClick(pump);
  };

  const handleCheckboxChange = (pumpId, checked) => {
    if (!onSelectionChange) return;
    if (checked) {
      onSelectionChange([...selectedPumpIds, pumpId]);
    } else {
      onSelectionChange(selectedPumpIds.filter((id) => id !== pumpId));
    }
  };

  const allVisibleSelected = pumps.length > 0 && pumps.every((p) => selectedPumpIds.includes(p.id));
  const someVisibleSelected = pumps.some((p) => selectedPumpIds.includes(p.id));
  const selectAllRef = useRef(null);
  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = someVisibleSelected && !allVisibleSelected;
    }
  }, [someVisibleSelected, allVisibleSelected]);

  return (
    <div className="pump-list">
      {selectModeEnabled && pumps.length > 0 && (
        <div className="pump-list-select-all d-flex align-items-center flex-wrap gap-2 p-3 border-bottom bg-light">
          <div className="d-flex align-items-center">
            <input
              ref={selectAllRef}
              type="checkbox"
              className="form-check-input pump-list-checkbox"
              id="pump-list-select-all"
              checked={allVisibleSelected}
              onChange={(e) => onSelectAll && onSelectAll(e.target.checked)}
            />
            <label className="form-check-label mb-0 ms-2" htmlFor="pump-list-select-all" style={{ cursor: 'pointer', userSelect: 'none' }}>
              {t('pump_select_all')}
            </label>
          </div>
          <button
            type="button"
            className={`btn btn-link p-0 pump-list-bulk-link ms-md-auto ${selectedPumpIds.length === 0 ? 'text-secondary' : 'text-dark'}`}
            onClick={onOpenBulkUpdate || undefined}
            disabled={selectedPumpIds.length === 0}
            title={selectedPumpIds.length === 0 ? t('pump_select_one_minimum') : t('pump_change_selected_title')}
          >
            <i className="fas fa-exchange-alt me-1" aria-hidden />
            <span className="pump-list-bulk-link-label">{t('pump_change_status_link')}</span>
          </button>
        </div>
      )}
      {pumps.map((pump, idx) => (
        <div
          key={pump.id ?? idx}
          onClick={(e) => handleRowClick(pump, e)}
          style={{ cursor: 'pointer' }}
          className={`d-flex align-items-stretch ${selectedPumpId && pump.id === parseInt(selectedPumpId) ? 'pump-card-selected' : ''}`}
        >
          {selectModeEnabled && (
            <div className="d-flex align-items-center px-2 border-bottom pump-list-checkbox-wrap" onClick={(e) => e.stopPropagation()}>
              <input
                type="checkbox"
                className="form-check-input pump-list-checkbox"
                checked={selectedPumpIds.includes(pump.id)}
                onChange={(e) => handleCheckboxChange(pump.id, e.target.checked)}
              />
            </div>
          )}
          <div className="flex-grow-1">
            <PumpCard {...pump} />
          </div>
        </div>
      ))}
    </div>
  );
} 